import { Link } from 'react-router-dom';

const MENU_ITEMS = [
    {
        label: '마케팅 서비스',
        to: '/consulting',
        src: '/static/img/icon/menu_09.svg',
    },
    {
        label: '마케팅 의뢰하기',
        to: '/marketingCompare',
        src: '/static/img/icon/menu_10.svg',
    },
    {
        label: '전문가 서비스',
        to: '/expert',
        src: '/static/img/icon/menu_11.svg',
    },
];

const MobileShortCutMenu = () => {
    return (
        <ul className="icon-menu-list mo-only">
            {MENU_ITEMS.map(({ label, to, src }) => (
                <li key={to}>
                    <Link to={to}>
                        <div className="icon-menu-thumb">
                            <img src={src} alt="" />
                        </div>
                        <p>{label}</p>
                    </Link>
                </li>
            ))}
        </ul>
    );
};

export default MobileShortCutMenu;
